// extracted by mini-css-extract-plugin
export default {"Container":"drHfJgwEKONlSZbERFMf","Container_reverse":"bttHI0faA7HMLQZjtDtV","Products":"ZXF48QID5pBWqSbq22ez","Products__results-count":"AgERm3bIjr8LIuOihabA"};